import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HomePage } from "./pages/home/HomePage";
import { ContactPage } from "./pages/contact/ContactPage";
import { ServicePage } from "./pages/services/ServicePage";
import { AboutPage } from "./pages/about/AboutPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/services",
    element: <ServicePage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
